import { render, staticRenderFns } from "./FormCustomer.vue?vue&type=template&id=86916dd4&scoped=true&"
import script from "./FormCustomer.vue?vue&type=script&lang=ts&"
export * from "./FormCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86916dd4",
  null
  
)

export default component.exports